/**
 * 야옹콘 진입 시 미인증 사용자용 오버레이 (피그마 1_인증필요)
 */
export default function PhoneCertGate({ open, onVerify, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black/80 px-5"
      role="dialog"
      aria-modal="true"
      aria-labelledby="phone-cert-gate-title"
      onClick={onClose}
    >
      <div
        className="flex w-full max-w-[340px] flex-col items-center gap-10"
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          id="phone-cert-gate-title"
          className="text-center font-['Pretendard'] text-[18px] font-bold leading-[1.6] text-white"
        >
          기프트콘을 구매하려면
          <br />
          휴대폰 인증이 필요해요
        </h2>
        <button
          type="button"
          onClick={onVerify}
          className="flex h-[46px] w-full items-center justify-center rounded-[10px] border border-solid border-black/12 bg-white font-['Pretendard'] text-[14px] font-bold text-gray05"
        >
          번호 인증하기
        </button>
      </div>
    </div>
  );
}
